import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Toaster } from "sonner";

export default function Layout() {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-brand-cream text-brand-charcoal" data-route={pathname}>
      <Navbar />
      <main className="pt-0">
        <Outlet />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1A201C",
            color: "#F7F5F0",
            border: "1px solid #2C4C3B",
            borderRadius: 0,
            fontFamily: "Work Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}
